import type {
  Filter,
  GetHotelReviewsResponse,
  SortType,
} from '@shared/types/frontend/ubff/hotel-reviews';

const cacheStore = new Map<string, GetHotelReviewsResponse>();

const useHotelReviewsCache = () => {
  const getCacheKey = (
    offset: number,
    hotelId: string,
    filters: Filter[],
    sortType: SortType,
  ) => `${hotelId}-${offset}-${sortType}-${JSON.stringify(filters)}`;

  const getCachedData = (key: string) => cacheStore.get(key);

  const updateCache = (key: string, data: GetHotelReviewsResponse) =>
    cacheStore.set(key, data);

  return {
    getCacheKey,
    getCachedData,
    updateCache,
  };
};

export default useHotelReviewsCache;
